import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=9ca420f0&scoped=true&"
import script from "./AccountStatement.vue?vue&type=script&lang=js&"
export * from "./AccountStatement.vue?vue&type=script&lang=js&"
import style0 from "./AccountStatement.vue?vue&type=style&index=0&id=9ca420f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca420f0",
  null
  
)

export default component.exports